import "./_estate-card-details-splitview.scss"

import React, {useRef} from "react";
import {Distribution, FlowchartEstateType, RevocableTrust} from "../../../EstateFlowchart/model/EstateFlowchartTypes";
import {useAppSelector} from "../../../store/hooks";
import {getEstateFlowchartsSelector} from "../../../EstateFlowchart/slices/EstateFlowChartSlice";
import {SideDrawerDetails} from "../../../EstateFlowchart/components/SideDrawer/SideDrawer";
import SideDrawerContentTrust from "../../../EstateFlowchart/components/SideDrawer/SideDrawerContentTrust";
import {PresentationPaneHeader} from "../../../components";
import {ReactFlowProvider} from "@xyflow/react";
import FlowchartVisualMain from "../../../EstateFlowchart/components/FlowchartVisual/FlowchartVisualMain";
import PrintViewWrapper from "../PrintViewWrapper";
import {CardDetailFieldsSections} from "../../../EstateFlowchart/utils/DrawerUtils";
import {Will} from "src/EstateFlowchart/model/Will";
import {IrrevocableTrust} from "../../../EstateFlowchart/model/IrrevocableTrust";
import {Miscellaneous} from "../../../EstateFlowchart/model/Miscellaneous";

type EstateCardDetailsSplitView = {
    flowchartId: string;
    selectedCardId: string;
    selectedCardDetails: SideDrawerDetails;
    estateName: string,
    displayName: string,
    sideDrawerItem: RevocableTrust | IrrevocableTrust | Will | Distribution | Miscellaneous,
    sideDrawerFields: CardDetailFieldsSections
}

const EstateCardDetailsSplitView: React.FC<EstateCardDetailsSplitView> = ({
                                                                              flowchartId,
                                                                              selectedCardId,
                                                                              selectedCardDetails,
                                                                              estateName,
                                                                              displayName,
                                                                              sideDrawerFields,
                                                                              sideDrawerItem
                                                                          }) => {
    const selectedCardRef = useRef<HTMLDivElement>(null);
    const estateFlowcharts = useAppSelector(getEstateFlowchartsSelector);

    return (
        <>{<PrintViewWrapper displayName={displayName} key={`card-details-${selectedCardId}`}>
            <div data-testid={`estate-card-details-split-view-${selectedCardId}`} style={{height: "87%"}}>
                <PresentationPaneHeader
                    displayName={"ESTATE FLOWCHART"}
                    callingFromDEFReport={true}
                    title={`${estateFlowcharts.find(ele => ele.flowchartId?.trim() === flowchartId.trim())!.flowchartName} | ${estateName}`}
                />
                <div className={"estate-card-split-view-container"}>
                    <article style={{flex: 1, background: "#f9f9f9"}}>
                        <div className={"estate-card-split-view-flowchart-section"}>
                            <ReactFlowProvider>
                                <FlowchartVisualMain
                                    estateType={estateName === "In Estate" ? FlowchartEstateType.IN_ESTATE : FlowchartEstateType.OUT_OF_ESTATE}
                                    flowcharts={estateFlowcharts}
                                    flowchartId={flowchartId}
                                    selectedCardId={selectedCardId}
                                    width={699}
                                    isInReportSplitView={true}
                                    selectedCardRef={selectedCardRef}
                                />
                            </ReactFlowProvider>
                        </div>
                    </article>
                    <aside style={{width: "699px", background: "#fff"}}>
                        <div className="side-drawer-header" style={{paddingLeft: "0", paddingTop: "0"}}>
                            <span className="header-title">{selectedCardDetails.title}</span>
                        </div>
                        {selectedCardDetails && sideDrawerFields &&
                            <div className={"estate-card-split-view-details-container"}>
                                <SideDrawerContentTrust sideDrawerItem={sideDrawerItem}
                                                        trustType={selectedCardDetails.cardType}
                                                        isInReportSplitView={true}
                                                        sideDrawerFields={sideDrawerFields}
                                />
                            </div>}
                    </aside>
                </div>
            </div>
        </PrintViewWrapper>}</>
    );
};

export default EstateCardDetailsSplitView;